import * as _ from 'lodash'
import { FocalPoint } from '@wix/thunderbolt-components-native'

const alignTypes = {
	CENTER: 'center',
	TOP: 'top',
	TOP_LEFT: 'top_left',
	TOP_RIGHT: 'top_right',
	BOTTOM: 'bottom',
	BOTTOM_LEFT: 'bottom_left',
	BOTTOM_RIGHT: 'bottom_right',
	LEFT: 'left',
	RIGHT: 'right',
}
const ALIGN_TYPE_TO_POSITION = {
	[alignTypes.CENTER]: '50% 50%',
	[alignTypes.TOP_LEFT]: '0% 0%',
	[alignTypes.TOP_RIGHT]: '100% 0%',
	[alignTypes.TOP]: '50% 0%',
	[alignTypes.BOTTOM_LEFT]: '0% 100%',
	[alignTypes.BOTTOM_RIGHT]: '100% 100%',
	[alignTypes.BOTTOM]: '50% 100%',
	[alignTypes.RIGHT]: '100% 50%',
	[alignTypes.LEFT]: '0% 50%',
}

const POSITION_TO_ALIGN_TYPE = Object.entries(ALIGN_TYPE_TO_POSITION).reduce(
	(acc: Record<string, string>, [align, position]) => {
		acc[position] = align
		return acc
	},
	{}
)

type Qualities = Array<{
	quality: string
	width: number
	height: number
	url: string
	format: 'mp4' | 'webm'
	formats?: Array<string>
}>

export const sortByQuality = (qualities: Qualities) =>
	_.sortBy(qualities, (qualityItem) => parseInt(qualityItem.quality, 10))

/**
 * Try to convert focal point value to 9 grid alignment value
 *
 * @param {Point}    focalPoint
 * @returns {string} align type
 */
export function convertFocalPointToAlignType(focalPoint: FocalPoint) {
	const position = `${focalPoint.x}% ${focalPoint.y}%`

	return POSITION_TO_ALIGN_TYPE[position] || ''
}
